export default {
  allLocationDefects: (state) => state.locationDefects,
  allTicketDefects: (state) => state.ticketDefects,
  defectsLoading: (state) => state.loading
}
